export default "__VITE_ASSET__2eb4afdc__"